
import { defineComponent } from 'vue';
import moment from 'moment'
export default defineComponent({
  name: 'App',
  mounted() {
    setInterval(() => {
      this.getTime()
    }, 1000)
  },
  data() {
    return {
      time: moment().format('h:mm:ss a'),
      userData:''
    }
  },
  methods: {
    getTime() {
      this.time = moment().format('h:mm:ss a')
    },
    getValue(e: any) {
      if(parseInt(e.target.innerText)){
        this.userData += e.target.innerText  
      }
      if(e.target.innerText === 'AC'){
        this.userData = '';
        document.querySelector('.result')!.innerHTML = ''
      }
      if(e.target.innerText === '.'){
        this.userData += e.target.innerText
      }
      if(e.target.innerText === '0'){
        this.userData += e.target.innerText
      }
      if(e.target.innerText === '-'){
        this.userData += '-';
      }
      if(e.target.innerText === '+'){
        this.userData += '+';
      }
      if(e.target.innerText === 'x'){
        this.userData += 'x';
      }
      if(e.target.innerText === '/'){
        this.userData += '/';
      }
      if(e.target.innerText === '%'){
        this.userData += '%';
      }
      if(e.target.classList.contains('fa-delete-left')){
        if(this.userData.length > 0){
          this.userData = this.userData.slice(0, -1)
        }
        }
      if(e.target.innerText === '='){
       // check if result includes the multiplication symbol
        if(this.userData.includes('x')){
          // replace the multiplication symbol with the multiplication sign
          this.userData = this.userData.replace('x', '*')
        }
        let result = eval(this.userData)
        if(result.toString().includes('.')){
          result = result.toFixed(2)
        }
        document.querySelector('.result')!.innerHTML = result
      }
    }
  },

});
